module.exports = __webpack_public_path__ + "img/banner_coun_guide_04.f1ab5066.png";